import { Component, Input } from '@angular/core';
import { PatientDetail } from "../../../../core/models/patient-detail.model";
import { PatientService } from "../../../../core/services/patient.service";
import { AlertService } from "../../../../shared/alert/alert.service";
import { LogHelper } from "../../../../core/helpers/log.helper";

@Component({
  selector: 'app-patient-login-info',
  templateUrl: './patient-login-info.component.html',
  styleUrl: './patient-login-info.component.scss'
})
export class PatientLoginInfoComponent {
  @Input() patient: PatientDetail = null;

  isOpen: boolean = false;
  recalculating = false;

  constructor(private patientService: PatientService, private alertService: AlertService) {}

  toggle() {
    this.isOpen = !this.isOpen;
  }

  getStudyPhaseDate() {
    if (!this.patient) {
      return null;
    }

    return this.patient.treatmentPhaseStartDate ?? this.patient.addedToTrialDate ?? null;
  }

  recalculateStudyPhase() {
    if (!this.patient?.patientTrialId) {
      return;
    }

    this.recalculating = true;
    this.patientService.recalculateStudyPhase(this.patient.patientTrialId).subscribe({
      next: response => {
        this.patient.studyPhase = response.studyPhase;
        this.patient.treatmentPhaseStartDate = response.treatmentPhaseStartDate ? new Date(response.treatmentPhaseStartDate) : null;
        this.patient.addedToTrialDate = response.addedToTrialDate ? new Date(response.addedToTrialDate) : this.patient.addedToTrialDate;
        this.recalculating = false;
      },
      error: error => {
        LogHelper.log(error);
        this.alertService.showWarningAlert('Sorry, there was a problem recalculating the study phase.');
        this.recalculating = false;
      }
    });
  }
}
